import React from 'react'

/* eslint-disable import/no-cycle */
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import { fetchChannel } from 'actions/catalog/channels'
import { clearPurchaseDataTemp } from 'actions/reservation'
import ErrorDesktop from 'assets/error-desktop.svg'
import ErrorMobile from 'assets/error-mobile.png'
import OopsError from 'components/errors/oops-error'
import CHECKOUT_STEPS from 'constants/checkoutStepBar'
import { getCatchedApiError } from 'selectors/apiError'
import { isDirectPayment } from 'selectors/catalog/channels'
import api from 'services/api'

import { generateHomeRoute } from '../helpers/url/localization'

export default function withErrorHandling(WrappedComponent) {
  class WrappedWithErrorHandling extends React.Component {
    state = {
      errorCatched: false
    }

    componentDidMount() {
      this.props.fetchChannel(this.props.i18n.language)
    }

    componentDidCatch(error, info) {
      this.setErrorLog(error, info)

      this.setState({
        errorCatched: true
      })

      this.scrollToTop()
    }

    //TODO: remove this function when the task SOP-616 is resolved
    setErrorLog(error, info) {
      if (!this.props.isDirectPayment) return

      const {
        location: { pathname },
        stateRedux: {
          purchaseTemp: { data },
          steps: { currentStep }
        }
      } = this.props

      if (
        data &&
        (pathname.indexOf('checkout/payment') > 0 || pathname.indexOf('checkout/confirm') > 0) &&
        (CHECKOUT_STEPS.PAYMENT === currentStep.selectedStep ||
          CHECKOUT_STEPS.CONFIRM === currentStep.selectedStep)
      ) {
        const {
          stateRedux: { purchase, reservation }
        } = this.props

        if (purchase.data && purchase.data.hasOwnProperty('isUnticketed')) {
          delete purchase.data.isUnticketed
        }

        const body = {
          purchaseResponse: purchase.data,
          purchaseRequest: data,
          message: 'ComponentDidCatch Error',
          statusCode: purchase.status,
          exception: {
            pathname: pathname,
            componentDidCatchErrorInfo: info.componentStack,
            componentDidCatchError: error.stack,
            reservation: reservation,
            purchaseResponseError: purchase.error
          }
        }

        api
          .post('/v2/booking/client-errors', body)
          .then(() => this.props.clearPurchaseDataTemp())
          .catch(() => this.props.clearPurchaseDataTemp())
      }
    }

    scrollToTop() {
      if (typeof window !== 'undefined') {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      }
    }

    onButtonClick = () => {
      this.setState({
        errorCatched: false
      })

      if (this.props.history) {
        this.props.history.push(generateHomeRoute(this.props.i18n.language))
      }
    }

    render() {
      // TODO: Decide what to render based on api errorStatus or redirect to specific URL page.
      if (this.state.errorCatched || this.props.catchedApiError) {
        return (
          <OopsError
            secondaryTitle="general.error-pages.something-went-wrong"
            error={{ description: 'general.error-pages.try-later' }}
            buttonText="general.error-pages.go-to-home-page"
            image={ErrorDesktop}
            imageMobile={ErrorMobile}
            buttonClick={this.onButtonClick}
            center
          />
        )
      }

      return <WrappedComponent {...this.props} />
    }
  }

  const mapStateToProps = state => ({
    stateRedux: state,
    catchedApiError: getCatchedApiError(state),
    isDirectPayment: isDirectPayment(state)
  })

  const mapDispatchToProps = {
    clearPurchaseDataTemp,
    fetchChannel
  }

  return withTranslation()(connect(mapStateToProps, mapDispatchToProps)(WrappedWithErrorHandling))
}
